import { useState, useEffect } from 'react';
import { CountriesApiAdapter } from '../adapters';
import type { Country } from '../adapters';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';

export const useCountries = () => {
  const [countries, setCountries] = useState<Country[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const httpClient = createHttpClient(apiClientWH);
  const countriesAdapter = new CountriesApiAdapter(httpClient);

  const loadCountries = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await countriesAdapter.getCountries();
      setCountries(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar países');
      console.error('Error loading countries:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCountries();
  }, []);

  return {
    countries,
    loading,
    error,
    loadCountries,
  };
};
